var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "main-header" },
    [
      _c("mobile-menu", { attrs: { social: _vm.social, user: _vm.user } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "d-flex mobile-header d-md-none align-items-center justify-content-between",
        },
        [
          _c("img", {
            attrs: {
              src: require("@/assets/images/icons/infoDiagram-logo-sygnet.svg"),
              alt: "InfoDiagram Logo",
            },
          }),
          _vm._v(" "),
          _c("Search"),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "menu",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.toggleSideMenu.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "open",
                  attrs: {
                    width: "28",
                    height: "19",
                    viewBox: "0 0 28 19",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M0 19H28V15.8333H0V19ZM0 11.0833H28V7.91667H0V11.0833ZM0 0V3.16667H28V0H0Z",
                      fill: "#929292",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "svg",
                {
                  staticClass: "close",
                  attrs: {
                    width: "38",
                    height: "26",
                    viewBox: "0 0 38 26",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M0 25.1186H27.4444V20.9322H0V25.1186ZM0 14.6525H21.1111V10.4661H0V14.6525ZM0 0V4.18644H27.4444V0H0ZM38 20.074L30.4422 12.5593L38 5.04466L35.0233 2.09322L24.4678 12.5593L35.0233 23.0254L38 20.074Z",
                      fill: "#FFAA00",
                    },
                  }),
                ]
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid header-inner" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-4 d-none d-md-block" }, [
            _c(
              "div",
              [
                _c(
                  "router-link",
                  {
                    attrs: { to: "/panel/diagrams" },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.clearFiltering.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("img", {
                      staticStyle: { display: "block", width: "100%" },
                      attrs: {
                        src: require("@/assets/images/infodiagram-account.svg"),
                      },
                    }),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-8 d-none d-md-block" }, [
            _c(
              "div",
              {
                staticClass:
                  "row align-items-center justify-content-end d-flex user-nav",
              },
              [
                _c("div", { staticClass: "user-nav-item" }, [
                  _c(
                    "div",
                    { staticClass: "d-flex align-items-center" },
                    [
                      _c("img", {
                        staticClass: "user-icon",
                        attrs: {
                          src: require("@/assets/images/icons/user.svg"),
                        },
                      }),
                      _vm._v(" "),
                      _vm.user ? _c("my-profile-dropdown") : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "user-nav-item" },
                  [_vm.user ? _c("my-credits") : _vm._e()],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {},
                  [_vm.user ? _c("get-credits-button") : _vm._e()],
                  1
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.user ? _c("Navigation") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }